export default "__VITE_ASSET__D3swtk4Z__"